<template>
  <div class="account-transaction-table">
    <table class="table">
      <thead>
        <tr>
          <th>{{ $t("table.date") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.type") }}</th>
          <th>{{ $t("table.account") }}</th>
          <th>{{ $t("table.amount") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.hash") }}</th>
        </tr>
      </thead>
      <tbody v-for="transaction in transactions" :key="transaction.hash">
        <tr>
          <!-- date -->
          <td class="date">
            <a v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              {{ $utils.formatTimestamp(transaction.timestamp) }}
            </a>
          </td>
          <td class="type is-hidden-mobile" :class="typeStyle(transaction)">
            {{ typeDesc(transaction) }} <i v-if="!isContract(transaction)" :class="arrowClass(transaction)"></i>
          </td>
          <!-- account -->
          <td class="account">
            <a v-if="!isContract(transaction)" v-bind:href="'#/account/'+ otherAddress(transaction)">
              {{ otherAddress(transaction) }}
            </a>
            <span v-if="isContract(transaction)">
              <b-icon pack="fa" icon="file-text" type="is-primary" size="is-small"></b-icon>
              <a v-bind:href="'#/account/'+ otherAddress(transaction)">
                {{ otherAddress(transaction) }}
              </a>
            </span>
          </td>
          <!-- amount -->
          <td class="amount" :class="amountStyle(transaction)">
            <b>{{ amountSymbol(transaction) }}{{ $utils.formatAmount(transaction.value) }}</b>
          </td>
          <!-- hash -->
          <td class="hash is-hidden-mobile">
            <a v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              {{ $utils.formatHash(transaction.hash) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'account-transaction-table',
    computed: {
      coinName () {
        return this.$COINNAME
      }
    },
    methods: {
      isMe (t) {
        if (t.from && this.address) {
          return t.from.toLowerCase() === this.address.toLowerCase()
        } else {
          return false
        }
      },
      arrowClass (t) {
        return this.isMe(t) ? 'fa fa-arrow-circle-right' : 'fa fa-arrow-circle-left'
      },
      typeDesc (t) {
        if (t.what === 'contract_creation') {
          return this.$t('table.contract_creation')
        } else if (t.what === 'contract_invoke') {
          return this.$t('table.contract_invoke')
        }
        return this.isMe(t) ? this.$t('table.send') : this.$t('table.receive')
      },
      isContract (t) {
        return t.what !== ''
      },
      otherAddress (t) {
        const add = this.isMe(t) ? t.to : t.from
        return add
      },
      typeStyle (t) {
        return ''
        // if (this.isContract(t)) {
        //   return 'has-text-info'
        // }
        // return this.isMe(t) ? 'has-text-danger' : 'has-text-success'
      },
      amountStyle (t) {
        return ''
        // return this.isMe(t) ? 'has-text-danger' : 'has-text-success'
      },
      amountSymbol (t) {
        return !this.isMe(t) ? '+' : '-'
      }
    },
    props: ['address', 'transactions']
  }
</script>

<style lang="scss" scoped>
  .menu-label {
    color: #fff;
  }

  h2 {
    color: #fff;
  }

  blockquote {
    padding: 16px;
    border-left: none;
    margin: 0;
    background-color: #f8f8f8ba;
    code {
      background-color: transparent;
    }
  }

  code.breakable {
    word-break: break-all;
    white-space: pre-wrap;
    padding: 0;
  }

  table {
    width: 100%;
  }

  td {
    white-space: normal;
    a {
      color: #666;
    }
  }

  td:first-child {
    width: 7rem;
  }

  code {
    color: #fff;
    background-color: #4acb6b;
    word-break: keep-all;
  }

  table {
    thead {
      tr {
        border: 1px solid #4acb6b;
        border-width: 0 0 1px;
      }
      th {
        background-color: #e5e5e5;
        color: #000;
      }
    }
    tbody {
      td {
        background-color: #f8f8f8ba;
        border: 1px solid #4acb6b;
        border-width: 0 0 1px;
        color: #fff;
        font-weight: 500;

        code {
          color: #fff;
          background: transparent;
        }
      }
    }
  }

  .notification {
    margin-top: 2rem;
  }

  .json-container {
    padding-bottom: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AccountTransactionTable.vue